import AudioPlayerPage, { AudioPlayerPageProps } from './AudioPlayerPage';

export default AudioPlayerPage;
export type { AudioPlayerPageProps };
